<h1 mat-dialog-title class="active">
    {{ "app.dialog.cost-accounting.errors.title.label" | translate }}
</h1>
<div mat-dialog-content class="section-container">
    <div *ngIf="data.errors.missingPurchasePrices.length > 0" class="missing-data-section">
        <h4>{{ "app.dialog.cost-accounting.errors.missing-purchase-prices.label" | translate }}</h4>
        @for (missingPurchasePrice of data.errors.missingPurchasePrices; track missingPurchasePrice) {
            <div class="missing-data">
                <span>{{ missingPurchasePrice.articleNr }}</span>
            </div>
        }
    </div>

    <div *ngIf="data.errors.missingPlannedPurchasePrices.length > 0" class="missing-data-section">
        <h4>{{ "app.dialog.cost-accounting.errors.missing-planned-prices.label" | translate }}</h4>
        @for (missingPlannedPrice of data.errors.missingPlannedPurchasePrices; track missingPlannedPrice) {
            <div class="missing-data">
                <span>{{ missingPlannedPrice.articleNr }}</span>
            </div>
        }
    </div>

    <div *ngIf="data.errors.missingMovingAveragePrices.length > 0" class="missing-data-section">
        <h4>{{ "app.dialog.cost-accounting.errors.missing-moving-average-prices.label" | translate }}</h4>
        @for (missingMovingAveragePrice of data.errors.missingMovingAveragePrices; track missingMovingAveragePrice) {
            <div class="missing-data">
                <span>{{ missingMovingAveragePrice.articleNr }}</span>
            </div>
        }
    </div>

    <div *ngIf="data.errors.missingByProductRevenues.length > 0" class="missing-data-section">
        <h4>{{ "app.dialog.cost-accounting.errors.missing-revenue.label" | translate }}</h4>
        @for (missingRevenue of data.errors.missingByProductRevenues; track missingRevenue) {
            <div class="missing-data">
                <span>{{ missingRevenue.articleNr }}</span>
            </div>
        }
    </div>

    <div *ngIf="data.errors.missingCostCenterWages.length > 0" class="missing-data-section">
        <h4>{{ "app.dialog.cost-accounting.errors.missing-wages.label" | translate }}</h4>
        @for (missingWage of data.errors.missingCostCenterWages; track missingWage) {
            <div class="missing-data">
                <span>{{ missingWage.costCenterName }}</span>
            </div>
        }
    </div>
</div>
<div mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close (click)="close()">{{ "app.button.close.label" | translate }}</button>
</div>
